import { render, staticRenderFns } from "./PayCategory.vue?vue&type=template&id=67c875bd&scoped=true&"
import script from "./PayCategory.vue?vue&type=script&lang=js&"
export * from "./PayCategory.vue?vue&type=script&lang=js&"
import style0 from "./PayCategory.vue?vue&type=style&index=0&id=67c875bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c875bd",
  null
  
)

export default component.exports